import { apiClient } from './api';

export interface MisaJob {
  jobType: string;
  lastRun: string | null;
  status: 'success' | 'failed' | 'running' | 'never';
  duration?: number;
  recordsProcessed?: number;
  errorCount?: number;
}

export interface MisaJobLog {
  id: string;
  jobType: string;
  status: 'success' | 'failed';
  recordsProcessed: number;
  duration: number;
  errorMessage?: string;
  timestamp: string;
}

export interface MisaJobLogsResponse {
  data: MisaJobLog[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface MisaQueueStats {
  waiting: number;
  active: number;
  completed: number;
  failed: number;
  delayed: number;
}

export interface MisaSyncStats {
  totalSyncsToday: number;
  successRate: number;
  failedJobs: number;
  avgDuration: number;
}

export const misaService = {
  getJobStatuses: async (tenantId: string): Promise<{ data: MisaJob[]; stats: MisaSyncStats }> => {
    const response = await apiClient.get(`/misa/${tenantId}/jobs`);
    return response.data.data;
  },

  getJobLogs: async (
    tenantId: string,
    jobType: string,
    page: number = 1,
    limit: number = 20
  ): Promise<MisaJobLogsResponse> => {
    const response = await apiClient.get(`/misa/${tenantId}/jobs/${jobType}/logs`, {
      params: { page, limit },
    });
    return response.data.data;
  },

  triggerSync: async (tenantId: string, jobType: string): Promise<void> => {
    await apiClient.post(`/misa/${tenantId}/sync/${jobType}`);
  },

  triggerFullSync: async (tenantId: string): Promise<void> => {
    await apiClient.post(`/misa/${tenantId}/sync-all`);
  },

  getQueueStats: async (): Promise<MisaQueueStats> => {
    const response = await apiClient.get('/misa/queue/stats');
    return response.data.data;
  },
};

export default misaService;
